import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "fig-right",
  style: {"width":"40%"}
}

import { watch, ref } from 'vue';
import { engineStore } from "@wwtelescope/engine-pinia";

export interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cssVars?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accentColor?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  touchscreen?: any;
  showBlazeOverlay: boolean;
  showAlphaOverlay: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BottomSheet',
  props: /*@__PURE__*/_mergeModels({
    cssVars: { default: () => ({}) },
    accentColor: { default: () => 'accent' },
    touchscreen: { default: () => false },
    showBlazeOverlay: { type: Boolean, default: false },
    showAlphaOverlay: { type: Boolean }
  }, {
    "modelValue": {default: true},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['close', 'toggle-blaze', 'toggle-alpha'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { cssVars, accentColor, touchscreen } = props;

const tab = ref(0);

const showTextSheet = _useModel(__props, "modelValue");

const store = engineStore();

function playTour() {
  store.loadTour({ url: `${window.location.origin}/FindingCoronaBorealis.WTT`, play: true });
}

watch(() => showTextSheet, (newVal) => {
  if (!newVal) {
    emits('close');
  }
});


return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_funding_acknowledgement = _resolveComponent("funding-acknowledgement")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    style: _normalizeStyle(_unref(cssVars)),
    class: "bottom-sheet",
    id: "text-bottom-sheet",
    "hide-overlay": "",
    persistent: "",
    "no-click-animation": "",
    absolute: "",
    width: "100%",
    scrim: false,
    location: "bottom",
    modelValue: showTextSheet.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showTextSheet).value = $event)),
    transition: "dialog-bottom-transition"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        id: "bottom-sheet-card",
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
            height: "32px",
            color: _unref(accentColor),
            "slider-color": _unref(accentColor),
            id: "tabs",
            dense: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, {
                class: "info-tabs",
                tabindex: "0"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("h3", null, "Information", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_tab, {
                class: "info-tabs",
                tabindex: "0"
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("h3", null, "Using WWT", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "color", "slider-color"]),
          _createVNode(_component_font_awesome_icon, {
            id: "close-text-icon",
            class: "control-icon",
            icon: "times",
            size: "lg",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showTextSheet.value = false)),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (showTextSheet.value = false), ["enter"])),
            tabindex: "0"
          }),
          (tab.value==0)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 0,
                class: "info-text tab-items no-bottom-border-radius scrollable"
              }, {
                default: _withCtx(() => [
                  _cache[15] || (_cache[15] = _createElementVNode("p", null, "You may have heard that a star in our night sky is going to \"go nova\" soon. Learn what this means and how you can see the nova!", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("h4", null, "What is a nova?", -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("p", null, [
                    _createTextVNode(" Novas are bright stars that seem to appear out of nowhere. They are named for the Latin word for \"new.\" In reality, stars that \"go nova\" have been there the whole time, but they did not not appear very bright, and therefore were not obvious in the sky. An explosion of gas on the surface of the star (the nova event) temporarily makes the star much, "),
                    _createElementVNode("strong", null, "MUCH"),
                    _createTextVNode(" brighter than it was before. ")
                  ], -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("h4", null, "How do I see this nova?", -1)),
                  _createElementVNode("p", null, [
                    _cache[9] || (_cache[9] = _createTextVNode(" The star that will become a nova is named \"T Coronae Borealis.\" It is often referred to as \"T CrB\" for short and is also nicknamed the \"Blaze Star\" (Go to ", -1)),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('toggle-blaze')), ["prevent"]))
                    }, "T CrB"),
                    _cache[10] || (_cache[10] = _createTextVNode("). As the name suggests, it is located within the constellation Corona Borealis, the \"Northern Crown.\" ", -1)),
                    _createElementVNode("a", {
                      href: "#",
                      onclick: "return false;",
                      onClick: _cache[4] || (_cache[4] = () => playTour())
                    }, "This guide"),
                    _cache[11] || (_cache[11] = _createTextVNode(" explains how you can find Corona Borealis in your night sky. ", -1))
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("p", null, " On a clear night, go out and look for Corona Borealis, so you can get used to its U-shape in the sky. Once T CrB goes nova, which can be any day now, or possibly weeks or months from now, it will seem as if a new star appeared just to the lower left of the U shape of the constellation. ", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("h4", null, "How bright will the nova be?", -1)),
                  _createElementVNode("p", null, [
                    _cache[12] || (_cache[12] = _createTextVNode(" At its normal brightness, T CrB is about a 10th magnitude star. This is about 30-40 times fainter than the faintest star a person could see from a dark sky, so you would need a telescope to see it. When it goes nova, it is predicted to be about 2-2.5 magnitudes. It is comparable in brightness to Alphecca (Go to ", -1)),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('toggle-alpha')), ["prevent"]))
                    }, "Alphecca"),
                    _cache[13] || (_cache[13] = _createTextVNode("), the brightest star you can see in the crown of Corona Borealis. ", -1))
                  ]),
                  _cache[21] || (_cache[21] = _createElementVNode("h4", null, "What causes a nova?", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("p", null, " Novas occur in binary star systems where small, very dense, very hot stars called white dwarfs orbit another large star at close range. The gravitational pull from the white dwarf can pull gas from the outer layers of the large companion star onto the surface of the white dwarf. When enough of this gas collects on the surface of the white dwarf, it triggers a nuclear explosion that causes the temporary brightening of the nova. ", -1)),
                  _createElementVNode("figure", _hoisted_1, [
                    _createVNode(_component_v_img, { src: "https://www.nasa.gov/wp-content/uploads/2024/06/novacyg093500952-print.jpg" }),
                    _cache[14] || (_cache[14] = _createElementVNode("figcaption", null, "A red giant star and white dwarf orbit each other, similar to T Coronae Borealis, the Blaze Star. A disk of material is pulled off the red giant, into a disk, and then onto the white dwarf. (Credit: NASA / Goddard Space Flight Center) ", -1))
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("h4", null, "How do we know this nova is getting ready to blow?", -1)),
                  _cache[24] || (_cache[24] = _createElementVNode("p", null, " Luckily, novas only blow up the gas that has settled on the surface of the white dwarf, and NOT the white dwarf itself. This means that the white dwarf can pull a new round of gas from its companion star. In some nova systems, this cycle of collecting gas, going nova, collecting more gas, going nova again, happens at a repeatable timescale. For T CrB, this has happened roughly every 80 years. It last blew in 1946, and before that, it blew in 1866. Astronomers have observed changes in the star's overall brightness that suggest it is getting ready to go nova again soon! ", -1)),
                  _cache[25] || (_cache[25] = _createElementVNode("h4", null, "Why does this star have multiple names?", -1)),
                  _cache[26] || (_cache[26] = _createElementVNode("p", null, " Astronomers usually name stars for the constellation they are in, and approximately for the relative brightness within the constellation, as designated by Greek letters. For example, the brightest star in Corona Borealis, Alphecca, is also known as α-CrB. The 2nd brightest star is β-CrB. ", -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("p", null, " The astronomer Friedrich Argelander began the practice of assigning Roman letters to stars that vary in brightness, beginning with the letter R. So the \"T\" in T CrB means that it is the third variable star discovered within Corona Borealis. ", -1)),
                  _cache[28] || (_cache[28] = _createElementVNode("p", null, [
                    _createTextVNode(" The nickname \"Blaze Star\" was given to T CrB after it \"blazed forth suddenly\" on May 12, 1866, becoming as bright as Alphecca. Learn more about the history in this 1897 "),
                    _createElementVNode("a", {
                      href: "https://articles.adsabs.harvard.edu/pdf/1897PA......5...97P",
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "article"),
                    _createTextVNode(", "),
                    _createElementVNode("em", null, "Heavens for June"),
                    _createTextVNode(" (see section \"The Northern Crown\"), by Mary Proctor. ")
                  ], -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (tab.value==1)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 1,
                class: "info-text tab-items no-bottom-border-radius scrollable"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { align: "center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_chip, {
                                label: "",
                                outlined: ""
                              }, {
                                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                  _createTextVNode(" Pan ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "pt-1"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("strong", null, _toDisplayString(_unref(touchscreen) ? "press + drag" : "click + drag"), 1),
                              _createTextVNode(" " + _toDisplayString(_unref(touchscreen) ? ":" : "or") + " ", 1),
                              _createElementVNode("strong", null, _toDisplayString(_unref(touchscreen) ? ":" : "W-A-S-D"), 1),
                              _createTextVNode(" " + _toDisplayString(_unref(touchscreen) ? ":" : "keys"), 1),
                              _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, { align: "center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_chip, {
                                label: "",
                                outlined: ""
                              }, {
                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                  _createTextVNode(" Zoom ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "pt-1"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("strong", null, _toDisplayString(_unref(touchscreen) ? "pinch in and out" : "scroll in and out"), 1),
                              _createTextVNode(" " + _toDisplayString(_unref(touchscreen) ? ":"
                    : "or") + " ", 1),
                              _createElementVNode("strong", null, _toDisplayString(_unref(touchscreen) ? ":" : "I-O"), 1),
                              _createTextVNode(" " + _toDisplayString(_unref(touchscreen) ? ":" : "keys"), 1),
                              _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "credits" }, [
                                _createElementVNode("h3", null, "Credits:"),
                                _createElementVNode("h4", null, [
                                  _createElementVNode("a", {
                                    href: "https://www.cosmicds.cfa.harvard.edu/",
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "CosmicDS"),
                                  _createTextVNode(" Vue Data Stories Team:")
                                ]),
                                _createTextVNode(" John Lewis"),
                                _createElementVNode("br"),
                                _createTextVNode(" Jon Carifio"),
                                _createElementVNode("br"),
                                _createTextVNode(" Pat Udomprasert"),
                                _createElementVNode("br"),
                                _createTextVNode(" Alyssa Goodman"),
                                _createElementVNode("br"),
                                _createTextVNode(" Mary Dussault"),
                                _createElementVNode("br"),
                                _createTextVNode(" Harry Houghton"),
                                _createElementVNode("br"),
                                _createTextVNode(" Anna Nolin"),
                                _createElementVNode("br"),
                                _createTextVNode(" Evaluator: Sue Sunbury"),
                                _createElementVNode("br"),
                                _createElementVNode("br"),
                                _createElementVNode("h4", null, "WorldWide Telescope Team:"),
                                _createTextVNode(" Peter Williams"),
                                _createElementVNode("br"),
                                _createTextVNode(" A. David Weigel"),
                                _createElementVNode("br"),
                                _createTextVNode(" Jon Carifio"),
                                _createElementVNode("br")
                              ], -1)),
                              _createVNode(_component_v_spacer, { class: "end-spacer" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_funding_acknowledgement)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style", "modelValue"]))
}
}

})